
export interface User {
  id?: any,
  title?: any;
  firstName?: any,
  lastName?: string,
  role?: any,
  email?: any,
  mobile?: any,
  password?: string,
  confirmPassword?: string,
  address?: string,
  isLogin?: string,
  statusCode?: number;
  accessToken?: any;
  employeeCode?: any;

  result?: any;
  totalItems?: any;
  expanded?: boolean;
  objArr?: any;
  ascordesc?: any;
  columnName?: any;
  notes?: any;
  responseStatus?: number;
  message?: string;
}

export enum UserType {
  ADMIN = "Admin",
  OPERATOR = "Operator",
  SUPERADMIN = "SuperAdmin",
}

export enum ViewType {
  ADD = "Add",
  CREATE = "Create",
  EDIT = "Edit",
  DELETE = "Delete",
  VIEW = "View",
  MODIFY = "Modify"
}

export enum ScreenType {
  INUSER = "Inuser",
  OUTUSER = "Outuser"
}

export enum UserStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive"
}
